import React from "react";

const Logo = (props) => {
  return (
    <img alt="Logo" src="/logo.png" width="42px" height="42px" {...props} />
  );
};

export default Logo;
